'use strict';

var bluebird = require('bluebird');
var _ = require('lodash');
var encode = require('hashcode').hashCode;
function InterlineFaresAdjustmentDataService(restangular) {
  var dataService = restangular.one('external').all('partnerAdjustments');
  var asyncConcurrency = {
    concurrency: 10
  };
  function save(partnerAdjustments) {
    return bluebird.map(partnerAdjustments, function (partnerAdjustment) {
      sanitizeItem(partnerAdjustment);
      return dataService.customPUT(partnerAdjustment);
    }, asyncConcurrency);
  }
  function remove(partnerAdjustments) {
    return bluebird.map(partnerAdjustments, function (partnerAdjustment) {
      sanitizeItem(partnerAdjustment);
      return dataService.customOperation('remove', '', {}, {
        'Content-Type': 'application/json'
      }, partnerAdjustment);
    }, asyncConcurrency);
  }
  function sanitizeItem(partnerAdjustment) {
    partnerAdjustment.partnerAirline = _.toUpper(_.trim(partnerAdjustment.partnerAirline));
    partnerAdjustment.partnerSegment = _.toUpper(_.trim(partnerAdjustment.partnerSegment));
    partnerAdjustment.trueOD = _.toUpper(_.trim(partnerAdjustment.trueOD));
    partnerAdjustment.classNames = _.replace(_.toUpper(partnerAdjustment.classNames), /\s+/ig, '');
    partnerAdjustment.groupKey = getGroupKey(partnerAdjustment);
    if (_.isEmpty(partnerAdjustment.trueOD)) {
      delete partnerAdjustment.trueOD;
    }
    if (_.isEmpty(partnerAdjustment.classNames)) {
      delete partnerAdjustment.classNames;
    }
    return partnerAdjustment;
  }
  function hashPartnerAdjustmentKey(partnerAdjustment) {
    return encode().value(_.pick(partnerAdjustment, ['partnerSegment', 'partnerAirline', 'trueOD', 'classNames']));
  }
  function getGroupKey(partnerAdjustment) {
    return [partnerAdjustment.partnerSegment, partnerAdjustment.partnerAirline, partnerAdjustment.trueOD].join(':');
  }
  return {
    save: save,
    remove: remove,
    sanitizePartnerAdjustment: sanitizeItem,
    hashPartnerAdjustmentKey: hashPartnerAdjustmentKey,
    getGroupKey: getGroupKey
  };
}
InterlineFaresAdjustmentDataService.$inject = ['Restangular'];
module.exports = InterlineFaresAdjustmentDataService;